import { Link } from 'react-router-dom';

type EmptyStateProps = {
  icon?: string;
  title: string;
  description?: string;
  action?: { to: string; label: string };
};

export default function EmptyState({
  icon = 'ri-inbox-archive-line',
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-2xl text-foreground-400">
        <i className={icon}></i>
      </span>
      <h3 className="mt-4 font-heading text-base font-semibold text-foreground-900">
        {title}
      </h3>
      {description && (
        <p className="mt-1.5 max-w-md text-sm text-foreground-500">
          {description}
        </p>
      )}
      {action && (
        <Link
          to={action.to}
          className="mt-5 flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-refresh-line"></i>
          {action.label}
        </Link>
      )}
    </div>
  );
}